/**
 * Canonical App Store + Play Store URLs for the akihub mobile app.
 *
 * Override via VITE_PRD_{APPSTORE,PLAYSTORE}_URL only for staging, A/B experiments, or
 * UTM-wrapped campaign shortlinks. Apple uses a branded apple.co shortlink — keep it;
 * Apple resolves country + device variants server-side.
 *
 * For QR codes use the *_DEEPLINK constants (full apps.apple.com / play.google.com URL).
 * Reason: the iOS Camera + Android scanners only trigger the App Store / Play Store
 * Universal/App Link when the encoded URL is the canonical store URL. Shortlinks
 * (apple.co/...) require an HTTP redirect that the scanners resolve via Safari/Chrome
 * first, breaking the deep-link into the store app.
 */

const PLAYSTORE_URL_FALLBACK =
	"https://play.google.com/store/apps/details?id=com.ezyhub.mobile";
const APPSTORE_URL_FALLBACK = "https://apple.co/4mERYvm";
const APPSTORE_DEEPLINK_FALLBACK =
	"https://apps.apple.com/br/app/akihub/id6761954921";

export const APPSTORE_URL =
	(import.meta.env.VITE_PRD_APPSTORE_URL as string | undefined)?.trim() ||
	APPSTORE_URL_FALLBACK;

export const PLAYSTORE_URL =
	(import.meta.env.VITE_PRD_PLAYSTORE_URL as string | undefined)?.trim() ||
	PLAYSTORE_URL_FALLBACK;

export const APPSTORE_DEEPLINK_URL =
	(import.meta.env.VITE_PRD_APPSTORE_DEEPLINK_URL as string | undefined)?.trim() ||
	APPSTORE_DEEPLINK_FALLBACK;

export const PLAYSTORE_DEEPLINK_URL = PLAYSTORE_URL;
